import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { postData } from "../newApis/dotNetApiMethods";

type TRepayment_Types = "Monthly" | "EndOfTenure";

type paramProps = {
  principalAmount?: number | "" | undefined;
  interestRate?: number | "" | undefined;
  tenure?: number | "" | undefined;
  repaymentPlan?: TRepayment_Types | "" | undefined | string;
  numberOfDaysInYear?: number | "";
};

const getInterestCalculation = async (query: paramProps) => {
  const {
    principalAmount,
    interestRate,
    tenure,
    repaymentPlan,
    numberOfDaysInYear,
  } = query;
  let isLoading = true;
  const { data } = await postData(ajaxEndpoints.GET_INTEREST_CALCULATION, {
    principal_amount: principalAmount,
    interest_rate: interestRate,
    tenure: tenure,
    interest_repayment_type: repaymentPlan,
    number_of_days_in_year: numberOfDaysInYear,
  });
  isLoading = false;
  return {
    data,
    isLoading,
    maturity_amount: data?.maturity_amount,
    monthly_interest_amount: data?.monthly_interest_amount,
  };
};

export default function useInterestCalculation({
  principalAmount,
  interestRate,
  tenure,
  repaymentPlan,
  numberOfDaysInYear,
}: paramProps) {
  return useQuery(
    [
      {
        principalAmount,
        interestRate,
        tenure,
        repaymentPlan,
        numberOfDaysInYear,
      },
      "getInterestCalculation",
    ],
    getInterestCalculation,
    {
      enabled: repaymentPlan?.length ? true : false,
      refetchOnWindowFocus: false, // Refetch on window focus
    }
  );
}
